module.exports = "img/flags/GA.2d6ac8a.png";